import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useRequirePlan } from '@/hooks/useRequirePlan';
import { PlanSelectionOnboarding } from './onboarding/PlanSelectionOnboarding';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { requiresPlanSelection, isLoading: loadingPlan } = useRequirePlan();

  // Loading state
  if (loading || loadingPlan) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to auth if not authenticated
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Show plan selection onboarding if required
  if (requiresPlanSelection) {
    return (
      <>
        <div className="blur-sm pointer-events-none">
          {children}
        </div>
        <PlanSelectionOnboarding />
      </>
    );
  }

  return <>{children}</>;
}
